(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var botones = document.querySelectorAll('[data-carrito-aplicar-descuento]');
    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var contenedor = boton.closest('.carrito__descuento');
        if (!contenedor) {
          return;
        }
        var input = contenedor.querySelector('[data-carrito-codigo-descuento]');
        if (!input) {
          return;
        }
        var codigo = input.value.trim();
        if (!codigo) {
          input.focus();
          return;
        }
        window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
    });
  });
})();
